module.exports = __webpack_public_path__ + "application/templates/default/partials/templates/menu-bar-inbox.template.html";